import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export type MenuLink = {
  name: string;
  url: string;
  icon: React.ElementType;
  mobileVisibility: boolean;
  order: number;
  visible: boolean;
};

type Props = MenuLink;

function HeaderButton({ name, url, icon: Icon }: Props) {
  const location = useLocation();
  const isActive = location.pathname === url;

  return (
    <Link
      to={url}
      data-tooltip-id="header-tooltip"
      data-tooltip-content={name}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg hover:bg-primary/10 transition-colors ${
        isActive ? "bg-primary/10" : ""
      }`}
    >
      <Icon className="h-5 w-5" />
      <span className="hidden md:block">{name}</span>
    </Link>
  );
}

export default HeaderButton; 